<template>
  <div id="welcome-section">
    <h2>Team</h2>
    <router-link to="/dashboard/team" class="minor cta-link">View</router-link>

    <div v-if="!showJoinLink">
      <p v-if="team.members_qty === 0">You have no team members, invite one now!</p>
      <p v-else>Invite more teammates below, or <router-link to="/dashboard/team">view team</router-link></p>
      <MessageFormGroup>
        <b-input-group>
          <b-form-input v-model="inviteEmail" size="sm" id="invite-email" placeholder="Email" />
          <div class="input-group-append">
            <b-btn size="sm" id="invite-button" @click="onClickInvite" variant="default"><i class="fa fa-envelope"/> Invite</b-btn>
          </div>
        </b-input-group>
      </MessageFormGroup>

      <div class="basic-tooltip" style="margin-top: 3px" :class="{show: heroState === 'step4'}">
        Enter an email here
      </div>

      <br>
      <div class="button-holder">
        <button class="btn switch-btn" @click="onShowJoinLink"><i class="fas fa-link"/> Share using link</button>
      </div>
    </div>
    <div v-else>
      <p>Share using link:</p>
      <TeamShareInput/>
      <br>

      <div class="button-holder">
        <button class="btn switch-btn" @click="onShowEmail"><i class="fas fa-email"/> Share using email</button>
      </div>
    </div>


  </div>
</template>

<script>
import {mapGetters} from 'vuex';
import wrapAction from "@/lib/bubble/wrapAction";
import {adminLinkShare} from "@/lib/track/events";

export default {
  data() {
    return {
      inviteEmail: '',
      showJoinLink: false
    };
  },
  computed: {
    ...mapGetters(['heroState', 'team', 'flags'])
  },
  methods: {
    onClickInvite: wrapAction({
      action: "inviteMember",
      arg: {data: "inviteEmail"},
      success: "Message has been sent!"
    }),
    onShowEmail() {
      this.showJoinLink = false;
      this.copied = false;
    },
    onShowJoinLink() {
      this.showJoinLink = true;
      adminLinkShare('reveal');
    }
  }
}
</script>

<style scoped lang="scss">
@import '~scss/colors';

.boxes {
  display: flex;
  flex-flow: row wrap;
}
.box {
  width: 50%;
  background: $white;
  border:1px solid rgb(192, 192, 192);
  padding: 2rem;
}
.full {
  width: 100%;
}
h1 {
  margin: 0;
}
#title {
  margin-bottom: 2em;
}

.button-holder {
  text-align: right;
  .switch-btn {
    padding-right: 0;
    margin-right: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pages/dashboard/home/TeamSection.vue